import React from "react";
import { withRouter } from "react-router-dom";
import Language from "../language/language";
import ReactGA from "react-ga";
import { inject, observer } from "mobx-react";
import {
  Form,
  Input,
  Button,
  Select,
  Cascader,
  Radio,
  Tooltip,
  message,
  Modal as ModalAntd
} from "antd";

import { $util, $const } from "../../helper";
import Modal from "../modal/modal";
import CheckErrorInfo from "../common/checkErrorInfo";
import ConfirmPersonalInfo from "../registrationCenter/confirmPersonalInfo";

import SchoolsForm from "./schoolsForm/index";

import "./stylesheets/createTeamForm.scss";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;

@inject("languageStore", "commonStore", "gameStore", "teamStore", "authStore")
@observer
@withRouter
class CreateTeam extends React.Component {
  state = {
    showCopyTeam: false,
    showCopyTeamModal: false,
    copyTeamId: "",
    chinaArea: [],
    showCheckModal: false,
    checkErrorInfo: [],
    submitIsLoading: false,
    confirmPersonalInfoModalState: false
  };

  componentDidMount() {
    if (this.props.teamStore.myTeams && this.props.teamStore.myTeams.length > 0) {
      this.setState({
        showCopyTeam: true
      });
    }
    this.setState({
      chinaArea: this.props.commonStore.pca
    });
  }

  closeCopyTeamModal = () => {
    this.setState({
      showCopyTeamModal: false
    });
  };

  copyTeamChange = e => {
    this.setState({
      copyTeamId: e.target.value
    });
  };

  openCopyTeamModal = () => {
    ReactGA.event({
      category: "Create-Team",
      action: "Click Copy Team Button"
    });
    this.props.commonStore.gTag("event", "createTeam", {
      pageName: "createTeam",
      buttonName: "copyTeam"
    });
    this.setState({
      showCopyTeamModal: true
    });
  };

  copyTeam = () => {
    if (!this.state.copyTeamId) {
      return;
    }
    const team = this.props.teamStore.myTeams.find(item => {
      return item.id === this.state.copyTeamId;
    });
    ReactGA.event({
      category: "Create-Team",
      action: "Copy History Team",
      label: team.id
    });
    this.props.commonStore.gTag("event", "createTeam", {
      pageName: "createTeam",
      buttonName: "copyTeamConfirm"
    });
    if (!team.collegeId && team.collegeName) {
      this.setState({
        showCopyTeamModal: false
      });
      this.props.form.getFieldValue("collegeName");
      this.props.form.getFieldValue("collegeBadge");
      this.props.form.getFieldValue("district");
      this.props.form.getFieldValue("collegeAbbreviation");
    } else {
      this.setState({
        showCopyTeamModal: false
      });
    }
    this.props.form.setFieldsValue({
      collegeId: team.collegeId,
      college: team.collegeId ? team.college && team.college.name : team.collegeName,
      collegeName: team.collegeId ? team.college && team.college.name : team.collegeName,
      collegeBadge: team.collegeBadge,
      collegeAbbreviation: team.collegeAbbreviation,
      district: team.district && team.district.split("-"),
      consigneeAddress: team.consigneeAddress,
      consigneeName: team.consigneeName,
      prefix: $util.formatPhone(team.consigneePhone)[0],
      consigneePhone: $util.formatPhone(team.consigneePhone)[1],
      teamType: team.teamType,
      name: team.name,
      nameEn: team.nameEn,
      campusOrganization: team.campusOrganization
    });
  };

  closeModal = () => {
    this.setState({
      showCheckModal: false
    });
  };

  openPersonalCenter = lang => {
    this.closeModal();
    $util.openPersonalCenter(lang);
  };

  verify = async values => {
    if (!values) return false;
    const { delegateSchools } = values;
    const userId = this.props.authStore.user && this.props.authStore.user.id;
    const gameId = this.props.gameStore.selectedGame && this.props.gameStore.selectedGame.id;
    const teamId = this.props.teamStore.joinInTeamInfo && this.props.teamStore.joinInTeamInfo.id;
    const checkRes = await $util.verifyPersonalInfo(userId, gameId, teamId, "2", delegateSchools);
    if (checkRes && checkRes.data && checkRes.data.result === 1) {
      return true;
    }
    if (checkRes && checkRes.data && checkRes.data.res && checkRes.data.res.length > 0) {
      // 创建战队校验不通过，仅校验当前用户，所以不用展示members
      const resData = checkRes.data.res.map(item => ({
        info: item.info
      }));
      this.setState({
        checkErrorInfo: resData
      });
    }
    return false;
  };

  onConfirmPersonalInfo = () => {
    this.setState({
      submitIsLoading: true
    });
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          // 如果填入的介绍链接包含http:// | https://那么直接提交，没有包含需要添加
          const introductionLinkOriginData = values.introductionLink || "";
          let introductionLinkData = "";
          if (!introductionLinkOriginData) {
            introductionLinkData = "";
          } else if (
            introductionLinkOriginData.indexOf("https://") === 0 ||
            introductionLinkOriginData.indexOf("http://") === 0
          ) {
            introductionLinkData = introductionLinkOriginData;
          } else {
            introductionLinkData = `https://${introductionLinkOriginData}`;
          }
          // 当前是选择状态
          await this.props.teamStore.createTeam({
            input: {
              attributes: {
                inviteCode: values.inviteCode,
                // 代表学校id
                collegeId: values.collegeId,
                // 学校所在地区，固定为空
                district: "",
                // 学校简称，固定为空
                collegeAbbreviation: "",
                // 学校名称，联队将学校名字用&拼接
                collegeName: values.delegateSchools ? values.delegateSchools.join("&") : "",
                // 校徽，固定为空
                collegeBadge: "",
                // 比赛id
                geventId: values.geventId,
                // 战队名
                name: values.name,
                // 战队类型
                teamType: values.teamType,
                // 收件地址
                consigneeAddress: values.consigneeAddress,
                // 收件人
                consigneeName: values.consigneeName,
                // 收件人联系方式
                consigneePhone: `${values.prefix.toString().indexOf("+") > -1 ? "" : "+"}${
                  values.prefix
                } ${values.consigneePhone}`,
                // 收件地址国家code
                consigneeCountryCode: values.area[0] ? values.area[0] : "",
                // 收件地址省份code
                consigneeProvinceCode: values.area[1] ? values.area[1] : "",
                // 收件地址城市code
                consigneeCityCode: values.area[2] ? values.area[2] : "",
                // 收件地址地区code
                consigneeDistrictCode: values.area[3] ? values.area[3] : "",

                nameEn: values.nameEn,
                // 介绍链接
                campusOrganization: values.campusOrganization,
                introductionLink: introductionLinkData,
                // 战队口号
                teamSlogan: values.teamSlogan
              }
            }
          });
          this.setState({
            submitIsLoading: false
          });
          this.props.history.push("/create-team-success");
        } catch (error) {
          this.setState({
            submitIsLoading: false
          });
          message.error(
            this.props.languageStore.lang === "zh"
              ? "创建失败，请稍后重试。"
              : "Failed to create, please try again later.",
            3
          );
        }
      } else {
        this.setState({
          submitIsLoading: false
        });
      }
    });
  };

  confirmInfoBeforeSubmit = () => {
    this.setState({
      submitIsLoading: true
    });
    if (!this.props.form.getFieldValue("inviteCode")) {
      this.props.form.setFieldsValue({
        inviteCode: $util.makeInviteCode()
      });
    }
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        // 表单校验通过，进行用户个人信息校验。
        const verifyRes = await this.verify(values);
        if (!verifyRes) {
          this.setState({
            showCheckModal: true,
            submitIsLoading: false
          });
          return;
        } else {
          this.setState({
            confirmPersonalInfoModalState: true,
            submitIsLoading: false
          });
          return;
        }
      } else {
        this.setState({
          submitIsLoading: false
        });
      }
    });
  };

  handleSubmit = () => {
    this.setState({
      submitIsLoading: true
    });
    if (!this.props.form.getFieldValue("inviteCode")) {
      this.props.form.setFieldsValue({
        inviteCode: $util.makeInviteCode()
      });
    }
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        // 表单校验通过，进行用户个人信息校验。
        const verifyRes = await this.verify(values);
        if (!verifyRes) {
          this.setState({
            showCheckModal: true,
            submitIsLoading: false
          });
          return;
        }
        try {
          // 如果填入的介绍链接包含http:// | https://那么直接提交，没有包含需要添加
          const introductionLinkOriginData = values.introductionLink || "";
          let introductionLinkData = "";
          if (!introductionLinkOriginData) {
            introductionLinkData = "";
          } else if (
            introductionLinkOriginData.indexOf("https://") === 0 ||
            introductionLinkOriginData.indexOf("http://") === 0
          ) {
            introductionLinkData = introductionLinkOriginData;
          } else {
            introductionLinkData = `https://${introductionLinkOriginData}`;
          }
          // 当前是选择状态
          await this.props.teamStore.createTeam({
            input: {
              attributes: {
                inviteCode: values.inviteCode,
                // 代表学校id
                collegeId: values.collegeId,
                // 学校所在地区，固定为空
                district: "",
                // 学校简称，固定为空
                collegeAbbreviation: "",
                // 学校名称，联队将学校名字用&拼接
                collegeName: values.delegateSchools ? values.delegateSchools.join("&") : "",
                // 校徽，固定为空
                collegeBadge: "",
                // 比赛id
                geventId: values.geventId,
                // 战队名
                name: values.name,
                // 战队类型
                teamType: values.teamType,
                // 收件地址
                consigneeAddress: values.consigneeAddress,
                // 收件人
                consigneeName: values.consigneeName,
                // 收件人联系方式
                consigneePhone: `${values.prefix.toString().indexOf("+") > -1 ? "" : "+"}${
                  values.prefix
                } ${values.consigneePhone}`,
                // 收件地址国家code
                consigneeCountryCode: values.area[0] ? values.area[0] : "",
                // 收件地址省份code
                consigneeProvinceCode: values.area[1] ? values.area[1] : "",
                // 收件地址城市code
                consigneeCityCode: values.area[2] ? values.area[2] : "",
                // 收件地址地区code
                consigneeDistrictCode: values.area[3] ? values.area[3] : "",

                nameEn: values.nameEn,
                // 介绍链接
                campusOrganization: values.campusOrganization,
                introductionLink: introductionLinkData,
                // 战队口号
                teamSlogan: values.teamSlogan
              }
            }
          });
          this.setState({
            submitIsLoading: false
          });
          this.props.history.push("/create-team-success");
        } catch (error) {
          this.setState({
            submitIsLoading: false
          });
          message.error(
            this.props.languageStore.lang === "zh"
              ? "创建失败，请稍后重试。"
              : "Failed to create, please try again later.",
            3
          );
        }
      } else {
        this.setState({
          submitIsLoading: false
        });
      }
    });
  };

  submitForm = e => {
    e.preventDefault();
    // 当前比赛的赛事类型id
    const curGameCategoryId = `${this.props.gameStore.selectedGame.attributes.category_id}`;
    if ($const.CONFIRM_PERSONAL_INFO_GAME_CATEGORY_IDS.includes(curGameCategoryId)) {
      // 只在部分赛事提示“信息确认弹框"
      this.confirmInfoBeforeSubmit();
    } else {
      this.handleSubmit();
    }
  };

  checkTeamName = (rule, value, callback) => {
    if (value) {
      value = value.trim();
      if (value.length < 1) {
        callback(<Language resource="INVALID_CHAR" />);
      }
      if (/[a-zA-Z]/.test(value.substr(0, 1)) && !/[A-Z]/.test(value.substr(0, 1))) {
        callback(<Language resource="MUST_BE_CAP" />);
      }
      if ($util.countWordsLength(value) > 16) {
        callback(<Language resource="CHAR_LIMIT" />);
      }
      if (
        value.indexOf("队") > -1 ||
        value.indexOf("*") > -1 ||
        value.indexOf("/") > -1 ||
        value.indexOf("-") > -1 ||
        value.indexOf("+") > -1
      ) {
        callback(<Language resource="ILLEG_CHAR" />);
      }
    }
    callback();
  };

  validatePhone = (rule, value, callback) => {
    const prefix = this.props.form.getFieldValue("prefix");
    // if (!value) return callback(<Language resource="EMPTY_PHONE" /> )
    if (value) {
      if (prefix.toString() === "86" || prefix.toString() === "+86") {
        if (!$const.CHINA_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      } else {
        // 国际号码只做最短、最长校验
        if (!$const.FOREIGN_PHONE.test(value)) callback(<Language resource="WRONG_PHONE" />);
        callback();
      }
    }
    callback();
  };

  areaOnChange = value => {
    this.props.form.setFieldsValue({
      consigneeDistrictCode: value[3] ? value[3] : "",
      consigneeCityCode: value[2] ? value[2] : "",
      consigneeProvinceCode: value[1] ? value[1] : "",
      consigneeCountryCode: value[0] ? value[0] : ""
    });
  };

  closeConfirmPersonalInfoModalState = () => {
    this.setState({
      confirmPersonalInfoModalState: false
    });
  };

  handleTeamTypeChange = value => {
    const delegateSchoolsO = this.props.form.getFieldValue("delegateSchools");
    this.props.form.setFieldsValue({
      delegateSchools: value === 1 ? delegateSchoolsO : delegateSchoolsO.slice(0, 1)
    });
  };

  render() {
    const lang = this.props.languageStore.lang;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    // 当前比赛的赛事类型id
    const curGameCategoryId = `${this.props.gameStore.selectedGame.attributes.category_id}`;
    // 创建战队和修改战队资料页面展示介绍链接的赛事类型id
    const showIntroductionLinkGameCategoryId = `${this.props.gameStore.showIntroductionLinkGameCategoryId}`;
    // 是否需要填写战队口号
    const showTeamSloganInput = this.props.gameStore.showTeamSloganGameCategoryId.includes(
      curGameCategoryId
    );

    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: 86
    })(
      <Select style={{ width: 100 }}>
        {$const.PHONE_PREFIX.map(item => {
          return <Option key={item} value={item}>{`+${item}`}</Option>;
        })}
      </Select>
    );

    const teamType = getFieldValue("teamType");

    // 国家
    let options = $const.COUNTRIES[lang];
    if (lang === "zh") {
      options[0].children = this.state.chinaArea;
    }
    return (
      <div className="create-team-form">
        <Form onSubmit={this.submitForm} className="create-team-form">
          <div className="create-team">
            <div className="title">
              <Language resource="CREATE_TEAM" />
            </div>
            <FormItem className="team-name-collegeId" style={{ display: "none" }}>
              {getFieldDecorator("collegeId", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeCountryCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeProvinceCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeCityCode", {})(<Input />)}
            </FormItem>
            <FormItem style={{ display: "none" }}>
              {getFieldDecorator("consigneeDistrictCode", {})(<Input />)}
            </FormItem>
            <FormItem
              className="team-name-item"
              label={<Language resource="TEAM_NAME" />}
              extra={<Language resource="TEAM_NAME_TIP" />}
            >
              {getFieldDecorator("name", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="PLEASE_ENTER_TEAM_NAME" />
                  },
                  {
                    validator: this.checkTeamName
                  }
                ]
              })(<Input />)}
              {this.state.showCopyTeam ? (
                <div className="copy-team spe-link" onClick={this.openCopyTeamModal}>
                  <Language resource="COPY_TEAM" />
                </div>
              ) : null}
            </FormItem>

            {this.props.languageStore.lang === "zh" && (
              <FormItem
                className="team-name-item"
                label={<Language resource="TEAM_NAME_EN" />}
                extra={<Language resource="TEAM_NAME_EN_TIP" />}
              >
                {getFieldDecorator("nameEn", {
                  rules: [
                    {
                      required: true,
                      message: <Language resource="PLEASE_ENTER_TEAM_NAME_EN" />
                    },
                    {
                      validator: this.checkTeamName
                    }
                  ]
                })(<Input />)}
              </FormItem>
            )}

            <FormItem className="team-type-item">
              {getFieldDecorator("teamType", {
                rules: [{ required: true }],
                initialValue: $const.TEAM_TYPE.TEAM,
                onChange: this.handleTeamTypeChange
              })(
                <Select>
                  <Option value={$const.TEAM_TYPE.TEAM}>
                    <Language resource="TEAM" />
                  </Option>
                  <Option value={$const.TEAM_TYPE.CONSORTIUM}>
                    <Language resource="CONSORTIUM" />
                  </Option>
                </Select>
              )}
            </FormItem>

            <FormItem label={<Language resource="ENTRY_PROJECT" />}>
              {getFieldDecorator("geventId", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="ENTRY_PROJECT_EMPTY_TIP" />
                  }
                ]
              })(
                <Select disabled>
                  <Option
                    key={this.props.gameStore.selectedGame.id}
                    value={this.props.gameStore.selectedGame.id}
                  >
                    {this.props.gameStore.selectedGame.attributes.title}
                  </Option>
                </Select>
              )}
            </FormItem>
            <FormItem className="team-name-collegeId" style={{ display: "none" }}>
              {getFieldDecorator("collegeName", {})(<Input />)}
            </FormItem>
            <FormItem
              label={<Language resource="TEAM_SCHOOL" />}
              className="create-team-form__form-item-school"
            >
              {getFieldDecorator("delegateSchools", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="TEAM_SCHOOL_EMPTY_TIP" />
                  }
                ]
              })(<SchoolsForm teamType={teamType} />)}
            </FormItem>
            <FormItem
              className="team-name-item"
              label={<Language resource="CAMPUS_ORGANIZATION" />}
              extra={<Language resource="CAMPUS_ORGANIZATION_TIP" />}
            >
              {getFieldDecorator("campusOrganization", {
                rules: [
                  {
                    required: this.props.languageStore.lang === "zh",
                    message: <Language resource="PLEASE_ENTER_CAMPUS_ORGANIZATION" />
                  }
                ]
              })(<Input />)}
            </FormItem>
            {showTeamSloganInput ? (
              <FormItem
                className="team-name-item"
                label={<Language resource="TEAM_SLOGAN" />}
                extra={<Language resource="TEAM_SLOGAN_TIPS" />}
              >
                {getFieldDecorator("teamSlogan", {
                  rules: [{ required: false }]
                })(<Input />)}
              </FormItem>
            ) : null}
            {curGameCategoryId === showIntroductionLinkGameCategoryId ? (
              <FormItem
                className="team-name-item"
                label={<Language resource="INTRODUCTION_LINKS" />}
                extra={<Language resource="INTRODUCTION_LINKS_TIP" />}
              >
                {getFieldDecorator("introductionLink", {
                  rules: [{ required: false }]
                })(<Input />)}
              </FormItem>
            ) : null}

            <FormItem className="addressee" label={<Language resource="ADDRESSEE" />}>
              {getFieldDecorator("consigneeName", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_RECIPIENT" />
                  }
                ]
              })(<Input />)}
            </FormItem>

            <FormItem label={<Language resource="ADDRESSEE_PHONE" />}>
              {getFieldDecorator("consigneePhone", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_PHONE" />
                  },
                  {
                    validator: this.validatePhone
                  }
                ]
              })(<Input addonBefore={prefixSelector} />)}
            </FormItem>

            <FormItem label={<Language resource="ADDRESSEE_ADRESS" />}>
              {getFieldDecorator("area", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_RECIPIENT" />
                  }
                ]
              })(
                <Cascader
                  placeholder={this.props.languageStore.getResource(lang, "AREA")}
                  options={options}
                  onChange={this.areaOnChange}
                />
              )}
            </FormItem>

            <FormItem className="emtpy-school-label" extra={<Language resource="ADDRESSEE_TIP" />}>
              {getFieldDecorator("consigneeAddress", {
                rules: [
                  {
                    required: true,
                    message: <Language resource="EMPTY_ADDRESS" />
                  }
                ]
              })(<Input />)}
            </FormItem>

            <FormItem className="submit">
              <Button type="primary" htmlType="submit" loading={this.state.submitIsLoading}>
                <Language resource="CREATE_TEAM" />
              </Button>
            </FormItem>
          </div>
        </Form>
        <Modal
          className="copy-team-modal"
          width={457}
          title={<Language resource="COPY_TEAM" />}
          state={this.state.showCopyTeamModal}
          close={this.closeCopyTeamModal}
        >
          <div className="sub-title">
            <Language resource="COPY_TEAM_TIP" />
          </div>
          <div className="team-list">
            <RadioGroup onChange={this.copyTeamChange} name="radiogroup">
              {this.props.teamStore.myTeams.map(team => {
                let title = `【${team.gevent &&
                  team.gevent.titleUuidI18n &&
                  team.gevent.titleUuidI18n[lang]}】${
                  team.collegeName
                    ? team.collegeName
                    : team.collegeId && team.college && team.college.name
                    ? team.college.name
                    : ""
                } ${team.name}`;
                return (
                  <Radio key={team.id} value={team.id}>
                    <Tooltip title={title}>{title}</Tooltip>
                  </Radio>
                );
              })}
            </RadioGroup>
          </div>
          <div className="opearate">
            <Button onClick={this.copyTeam} disabled={!this.state.copyTeamId}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
        <Modal
          title={<Language resource="PERSONAL_INFO_NOT_CHECKED" />}
          state={this.state.showCheckModal && this.state.checkErrorInfo.length > 0}
          close={this.closeModal}
          className="create-team-form__modal-box"
        >
          <CheckErrorInfo checkErrorInfo={this.state.checkErrorInfo} />
          <Button
            className="create-team-form__modal-btn"
            type="primary"
            htmlType="submit"
            onClick={() => this.openPersonalCenter(lang)}
          >
            <Language resource="CHANGE_PERSONAL_INFO" />
          </Button>
        </Modal>
        <ModalAntd
          footer={null}
          maskClosable={false}
          onCancel={this.closeConfirmPersonalInfoModalState}
          width={"585px"}
          title={<Language resource="CONFIRM_THE_ENTRY_INFO" />}
          destroyOnClose={true}
          visible={this.state.confirmPersonalInfoModalState}
        >
          <ConfirmPersonalInfo
            onClose={() => {
              this.setState({
                confirmPersonalInfoModalState: false
              });
            }}
            onConfirm={this.onConfirmPersonalInfo}
          />
        </ModalAntd>
      </div>
    );
  }
}

const CreateTeamForm = Form.create({
  mapPropsToFields(props) {
    return {
      geventId: Form.createFormField({
        value: props.eventId
      }),
      delegateSchools: Form.createFormField({
        value: [""]
      })
    };
  }
})(CreateTeam);

export default CreateTeamForm;



// WEBPACK FOOTER //
// ./src/components/createTeam/createTeamForm.js